<template>
  <l-layout :layout="['xs12']">
    <v-card>
      <l-data-table
        :headers="header"
        title-text="消息事件列表"
        ref="eventList"
        clickable
        @click:row="getDetails($event.item)"
        :get-data-func="getEventList">
        <template slot="row-action" slot-scope="{item}">
          <td @click.stop class="px-0 mx-0 text-xs-center">
            <v-tooltip left>
              <v-btn @click="deleteEventConfirm(item)" slot="activator" icon>
                <v-icon small>$vuetify.icons.delete</v-icon>
              </v-btn>
              <span>删除消息事件</span>
            </v-tooltip>
            <v-tooltip left>
              <v-btn @click="sendDialog = {activate: true, item: item}" slot="activator" icon>
                <v-icon small>mdi-email</v-icon>
              </v-btn>
              <span>发送消息</span>
            </v-tooltip>
          </td>
        </template>
      </l-data-table>
      <l-fixed-btn
        @click="addEvent"
        icon="$vuetify.icons.add"
      ></l-fixed-btn>
    </v-card>
    <v-dialog max-width="800px" persistent scrollable v-model="sendDialog.activate">
    <send-message-content
      :item="sendDialog.item"
      @cancel="sendDialog = {activate: false, item: {}}"
      v-if="sendDialog.activate"
    ></send-message-content>
    </v-dialog>
  </l-layout>
</template>

<script>
import sendMessageContent from './sendMessageContent'
export default {
  name: 'MessageEvent',
  components: {
    sendMessageContent
  },
  data () {
    return {
      header: [
        {text: '事件名称', value: 'name', align: 'left', sortable: false},
        {text: '创建者', value: 'creator', align: 'left', sortable: false},
        {text: '创建时间', value: 'creationTime', align: 'left', sortable: true, f: (v) => (this.$L.time.stringify(v))},
        {text: '', value: '', sortable: false, align: 'left'}
      ],
      sendDialog: {
        activate: false,
        item: {}
      },
    }
  },
  computed: {
    refresh () {
      // console.log(this.$store.state.message.classRefresh)
      return this.$store.state.message.eventRefresh
    }
  },
  activated () {
    if (this.refresh) {
      this.$refs.eventList.refresh()
      this.$store.commit('message/setEventRefresh', false)
    }
  },
  methods: {
    async getEventList ({pagination, sortStack, filterItems, search}) {
      let url = '/messageApi/getMsgEvent'
      let {items, amount} = await this.$store.dispatch('message/getList', {pagination, sortStack, filterItems, search: {key: 'name', value: search}, url: url})
      return {items, amount}
    },
    addEvent () {
      this.$router.push({name: 'newMessageEvent'})
    },
    async deleteEventConfirm (item) {
      let {res, close} = await this.$L.confirm({
        title: '确认删除该事件？',
        text: '事件名称:' + item.name
      })
      if (res) {
        try {
          await this.deleteEvent(item)
        }
        catch (e) {
          this.$L.alert('error', e.message)
        }
      }
      close()
    },
    async deleteEvent (item) {
      let url = '/messageApi/admin/deleteMsgEvent'
      let ids = []
      ids.push(item.id)
      let params = {'idList': ids}
      let res = await this.$store.dispatch('message/deleteActions', {params: params, url: url})
      if (res.data.code + '' === '200') {
        this.$L.alert('success', {message: '删除成功'})
        this.$refs.eventList.refresh()
      }
      else {
        this.$L.alert('error', {message: '删除失败，原因：' + res.data.msg})
      }
    },
    getDetails (item) {
      let selectionString = document.getSelection().toString()
      if (!selectionString) {
        this.$router.push({name: 'eventDetailBox', query: {id: item.id}})
      }
    }
  }
}
</script>

<style scoped>

</style>
